import { Component } from '@theme/component';
import { SlideshowSelectEvent } from '@theme/events';

/**
 * Collection Navigation Component - handles collection name navigation for carousels
 * @extends {Component}
 */
export class CollectionNavigation extends Component {
  connectedCallback() {
    super.connectedCallback();

    /** @type {import('./slideshow').Slideshow | null} */
    this.slideshow = this.closest('.section-resource-list')?.querySelector('slideshow-component');

    if (!this.slideshow) {
      console.warn('CollectionNavigation: No slideshow component found');
      return;
    }
    this.slideshow.addEventListener(SlideshowSelectEvent.eventName, this.#handleSlideshowSelect);

    setTimeout(() => {
      if (!this.slideshow) return;

      const currentIndex = this.slideshow.current || 0;
      const initialIndex = this.slideshow.initialSlideIndex || 0;

      if (initialIndex !== 0 && currentIndex === 0) {
        this.slideshow.select(initialIndex, undefined, { animate: false });
      }

      this.#updateNavigationState(this.slideshow.current || 0);
    }, 200);

    this.#updateNavigationState(this.slideshow?.current || 0);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.slideshow) {
      this.slideshow.removeEventListener(SlideshowSelectEvent.eventName, this.#handleSlideshowSelect);
    }
  }

  /**
   * Selects a specific slide by index
   * @param {Object|number} data - The data object containing index or direct index
   * @param {Event} event
   */
  selectSlide = (data, event) => {
    event?.preventDefault();

    const index = typeof data === 'object' && data !== null ? /** @type {any} */ (data).index : data;

    if (this.slideshow && typeof index === 'number') {
      const targetSlide = this.slideshow.slides?.[index];
      if (targetSlide) {
        targetSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        this.slideshow.current = index;
        this.#updateNavigationState(index);
      }
    }
  };

  /**
   * Handles slideshow select events
   * @param {SlideshowSelectEvent} event
   */
  #handleSlideshowSelect = (event) => {
    const { index } = event.detail;
    this.#updateNavigationState(index);
  };

  /**
   * Updates the navigation state
   * @param {number} activeIndex - The currently active slide index
   */
  #updateNavigationState = (activeIndex) => {
    const section = this.closest('.section-resource-list');
    if (!section) return;

    const navItems = section.querySelectorAll('.collection-nav-item');
    navItems.forEach((item, index) => {
      item.setAttribute('aria-selected', index === activeIndex ? 'true' : 'false');
    });
  };
}

if (!customElements.get('collection-navigation')) {
  customElements.define('collection-navigation', CollectionNavigation);
}
